import React from 'react';

import {
    SprayEntityIds,
    SprayWaterTotal,
    SprayWaterRate,
    SprayEventApplicationType
} from 'services/sprayEvents/types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import {
    isApplicationTypeNeedHalfCalculation,
    isMultiOperatorApplicationType
} from 'services/sprayEvents/utils';
import { HALF_THE_CALCULATION } from 'services/sprayEvents/constants';
import { makeSelectWaterTotal } from './selectors';

interface ConnectedProps {
    waterTotal?: SprayWaterTotal;
}

export interface OwnProps {
    waterRate: SprayWaterRate;
    entityIds: SprayEntityIds;
    applicationType: SprayEventApplicationType;
}

export type Props = OwnProps & ConnectedProps;

export class WaterTotalFieldComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { waterTotal, applicationType } = this.props;

        const getWaterTotalLabel = () => {
            if (isMultiOperatorApplicationType(applicationType)) {
                return 'Water Total per Applicator (Litres)';
            }

            return 'Water total (Litres)';
        };

        const getWaterTotal = () => {
            if (isApplicationTypeNeedHalfCalculation(applicationType)) {
                return waterTotal && waterTotal / HALF_THE_CALCULATION;
            }

            return waterTotal;
        };

        return (
            <div className="field">
                <label htmlFor="waterTotal">
                    {getWaterTotalLabel()}
                    <span className="read-only-field" id="waterTotal">
                        {getWaterTotal()}
                    </span>
                </label>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    waterTotal: makeSelectWaterTotal()
});

export default connect(mapStateToProps)(WaterTotalFieldComponent);
